import { Stack } from 'component-library';
import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { CONTACT_SUPPORT_EMAIL_ADDRESS } from '@/config/constants';

import { Card } from '../card/Card';

export const HelpWidget: FC<HTMLAttributes<HTMLDivElement>> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <Card
      label={t('buyer.investments.help.label')}
      data-testid='investment-help'
      data-cy='investments-help'
      className={className}
    >
      <Stack spacing={6} className='items-start'>
        <span className='typography-body1 whitespace-pre-wrap'>
          {t('buyer.investments.help.text', {
            email: CONTACT_SUPPORT_EMAIL_ADDRESS,
          })}
        </span>
      </Stack>
    </Card>
  );
};
